module.exports = __webpack_public_path__ + "media/components/Builder/Library/Images/Tools/MergeOptions-53b83b4572226f75046cb68ad95f4e40.svg";